import React from "react";
import { useCarConfigSelector } from "../../../../redux/store";
import { AemFmComponent } from "../../../../../../../common-deprecated/utils/aemFlexibilityMatrixUtils";
import { formatInsurancePrice } from "../../../../../../shared-logic/utils/insuranceUtils";

const InsurancePrice = (): JSX.Element | null => {
    const insurance = useCarConfigSelector((state) => state.insurance);
    const commonSettings = useCarConfigSelector((state) => state.commonSettings);

    const formattedPrice = formatInsurancePrice(insurance, AemFmComponent.Carconfig, commonSettings, false);

    if (insurance.fetching) return null;

    return (
        <>
            {formattedPrice.labels.map((item) => (
                <div key={item.key}>
                    <span dangerouslySetInnerHTML={{ __html: item.value }} />
                </div>
            ))}
        </>
    );
};

export default InsurancePrice;
